import { keys } from '@/app/i18n'
import type { SettingsTabDefinition } from '@/shared/settings/tabs'

/**
 * The six accounting tabs of the settings shell (WP-05b, D-14; wp/settings §1.1 rows 14–19), contributed through the
 * registry of `src/modules/settings` — this module never edits that folder. Slugs, labels, icons and order are
 * legacy's (`Settings.vue` `tabSets`, between Payment providers 130 and Job levels 200); the inbound links of the
 * invoice, quote and finance editors use these slugs (§1.4 (5)). Every tab is `ac` only. A Staff member sees a tab
 * with Invoicing read and its write controls with Invoicing write (FX-070, FX-058; OPEN-2 (a)); the invoice items list
 * is open (the editors read it), only its writes need Invoicing write.
 */
const tabs: SettingsTabDefinition[] = [
  {
    slug: 'quote-messages',
    label: keys.t('settingsAccounting.shell.tab.quoteMessages'),
    icon: 'BriefcaseIcon',
    order: 140,
    softwares: ['ac'],
    read: 'invoices',
    write: 'invoices',
    component: () => import('./components/tabs/QuoteMessagesTab.vue'),
  },
  {
    slug: 'payment-categories',
    label: keys.t('settingsAccounting.shell.tab.paymentCategories'),
    icon: 'BookmarkIcon',
    order: 150,
    softwares: ['ac'],
    read: 'invoices',
    write: 'invoices',
    component: () => import('./components/tabs/PaymentCategoriesTab.vue'),
  },
  {
    slug: 'invoice-messages',
    label: keys.t('settingsAccounting.shell.tab.invoiceMessages'),
    icon: 'MailIcon',
    order: 160,
    softwares: ['ac'],
    read: 'invoices',
    write: 'invoices',
    component: () => import('./components/tabs/InvoiceMessagesTab.vue'),
  },
  {
    slug: 'invoice-items',
    label: keys.t('settingsAccounting.shell.tab.invoiceItems'),
    icon: 'ListIcon',
    order: 170,
    softwares: ['ac'],
    write: 'invoices',
    component: () => import('./components/tabs/InvoiceItemsTab.vue'),
  },
  {
    slug: 'invoice-settings',
    label: keys.t('settingsAccounting.shell.tab.invoiceDesign'),
    icon: 'FilePlusIcon',
    order: 180,
    softwares: ['ac'],
    read: 'invoices',
    write: 'invoices',
    component: () => import('./components/tabs/InvoiceDesignTab.vue'),
  },
  {
    slug: 'invoice-series',
    label: keys.t('settingsAccounting.shell.tab.invoiceSeries'),
    icon: 'HashIcon',
    order: 190,
    softwares: ['ac'],
    read: 'invoices',
    write: 'invoices',
    component: () => import('./components/tabs/InvoiceSeriesTab.vue'),
  },
]

export default tabs
